import { useMemo } from 'react'

import { useOpportunities } from './use-opportunities'
import {
  buildJobSkillFacets,
  jobBrowseFiltersForSkillFacetHarvest,
} from '../lib/job-browse-filters'

/** Skill facet options are harvested from the full job pool — never narrowed by active browse filters. */
export function useJobSkillFacetHarvest() {
  const harvestFilters = useMemo(() => jobBrowseFiltersForSkillFacetHarvest(), [])

  const { opportunities: harvestOpportunities, isLoading } = useOpportunities(harvestFilters)

  const skillFacets = useMemo(
    () => buildJobSkillFacets(harvestOpportunities),
    [harvestOpportunities],
  )

  return { skillFacets, skillFacetsLoading: isLoading }
}
